import ByUser from './ByUser'
import withByUser from './withByUser'

const ConnectedByUser = withByUser(ByUser)

export { ConnectedByUser as ByUser }
